import React from 'react';
import PropTypes from 'prop-types';

import Label from '../../../../../../components/Label';
import Select from '../../../../../../components/Select';
import {
  EMAIL,
  MIXPANEL_COHORT_ID,
} from '../../../../../../forms/messages/sendMessageForm';

const RecepientSelect = (props) => {
  const { value, onChange, errors } = props;

  const options = [
    { value: '', label: '-- Choose recepient --' },
    { value: EMAIL, label: 'Single User' },
    { value: MIXPANEL_COHORT_ID, label: 'Mixpanel Cohort' },
  ];

  return (
    <div>
      <Label name="recepient" title="Recepient" errors={errors} />
      <Select
        id="recepient"
        options={options}
        value={value}
        onChange={onChange}
        required
      />
    </div>
  );
};

export default RecepientSelect;

RecepientSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.shape(),
};

RecepientSelect.defaultProps = {
  value: '',
  errors: {},
};
